import { useFetchViews } from './useFetchViews'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { queryKeys, type QueryViewByIdCacheData } from './useQueryViews'

const create = () => {
  const { create } = useFetchViews()
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: create,
    onMutate: () => {
      cancelQueries([queryKeys.all._def])
    },
    onSuccess: () => {
      invalidateQueries([queryKeys.all._def])
    },
  })
}

const update = () => {
  const { update } = useFetchViews()
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: update,
    onMutate: (variables) => {
      cancelQueries([
        queryKeys.byId({ id: variables.id, workspaceId: variables.workspaceId }).queryKey,
        queryKeys.all._def,
      ])
    },
    onSuccess: (responseData, variables) => {
      invalidateQueries([
        queryKeys.all._def,
      ])

      queryClient.setQueriesData<QueryViewByIdCacheData>({
        queryKey: queryKeys.byId({ id: variables.id, workspaceId: variables.workspaceId }).queryKey,
      }, (oldData) => {
        if (!oldData)
          return oldData

        return {
          ...oldData,
          data: responseData.data,
        }
      }, {
        updatedAt: Date.now(),
      })
    },
  })
}

const drop = () => {
  const { drop } = useFetchViews()
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: drop,
    onMutate: (variables) => {
      cancelQueries([
        queryKeys.byId({ id: variables.id, workspaceId: variables.workspaceId }).queryKey,
        queryKeys.all._def,
      ])
    },
    onSuccess: (_, variables) => {
      invalidateQueries([queryKeys.all._def])
      queryClient.removeQueries({
        queryKey: queryKeys.byId({ id: variables.id, workspaceId: variables.workspaceId }).queryKey,
      })
    },
  })
}

export const useMutationViews = {
  create,
  update,
  drop,
}
